module.exports = __webpack_public_path__ + "assets/img/2023_1.1d0b3e08.png";